import { useEffect, useState, useCallback } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { Link, useParams } from 'react-router-dom';
import getStatus from './getStatus.js';
import { ko } from "date-fns/esm/locale";
import { addDays, differenceInDays } from 'date-fns';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { collection, query, onSnapshot } from "firebase/firestore";
import { dbService } from "fbase";
import { doc, updateDoc } from "firebase/firestore";

function Productinfo({userObj}){
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const {productid} = useParams();
    const productTextRef = doc(dbService, "productlist", `${productid}`)
    const [product, setProduct] =useState({});
    const [productlist, setProductlist] = useState([]);
    const getProduct = useCallback(() => {
        const q = query(collection(dbService, "productlist"));
        onSnapshot(q, (snapshot) => {
            const productArr = snapshot.docs.map((doc) => ({
                fbid: doc.id,
                ...doc.data()
            }));
            setProductlist(productArr);
            productlist.map((product => product.fbid === productid ? setProduct(product) : null))
        })
    }, [productid, productlist])
    useEffect(()=>{
        getProduct();
    }, [getProduct])
    const [index, setIndex] = useState(0);
    const [editing, setEditing] = useState(false);
    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    useEffect(() => {
        handleSelect();
    }, []);

    // const options = {
    //     day: 'numeric',
    //     month: 'long', 
    //     year: 'numeric',
    //     weekday: 'short'
    // };

    const today = new Date();

    const [state, setState] = useState([
        {
            startDate: new Date(),
            endDate: addDays(new Date(), 7),
            key: "selection",
        }
    ])

    const firstDay = new Intl.DateTimeFormat("kr-KO").format(state[0].startDate);
    const lastDay = new Intl.DateTimeFormat("kr-KO").format(state[0].endDate);

    const [days, setDays] = useState(differenceInDays(state[0].endDate, state[0].startDate));

    useEffect(()=>{
        setDays(differenceInDays(state[0].endDate, state[0].startDate));
    }, [state])

    const [repair, setRepair] = useState(product.repair);
    const getRepair = () => {
        const repairCheck = document.getElementById("repair");
        if(repairCheck.checked){
            setRepair(true)
        } else {
            setRepair(false)
        }
    }

    const [damage, setDamage] = useState(product.damage);
    const getDamage = () => {
        const damageCheck = document.getElementById("damage");
        if(damageCheck.checked){
            setDamage(true)
        } else {
            setDamage(false)
        }
    }

    const [desc, setDesc] = useState(product.desc);
    const onChange = (e) => {
        setDesc(e.target.value);
    }

    const handleEditing = () => {
        setEditing(!editing);
        if(product.reserv_date !== null || product.return_date !== null){
            setState([{
                startDate: new Date(product.reserv_date),
                endDate: new Date(product.return_date),
                key: "selection"
            }])
        }
        setRepair(product.repair)
        setDamage(product.damage)
        setDesc(product.desc)
    }

    const onSubmit = async (event) => {
        event.preventDefault();
        await updateDoc(productTextRef, {
            repair: repair,
            damage: damage,
            reserv_date: firstDay,
            return_date: lastDay,
            desc: desc
        })
        setEditing(false);
    }

    return (
        <div className="container py-5 bg-light" style={{marginTop: "2.5rem"}} id="productinfo">
            <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6 col-xl-4">
                    <div className="card" style={{borderRadius: "15px"}}>
                        <div className="bg-image hover-overlay ripple ripple-surface ripple-surface-light"
                            data-mdb-ripple-color="light">
                                <Carousel activeIndex={index} onSelect={handleSelect} indicators={true}>
                                    { product.imgSrc && product.imgSrc.map((img) => (
                                        <Carousel.Item key={img}>
                                            <img
                                                className="img-fluid"
                                                src={img}
                                                style={{borderTopLeftRadius: "15px", borderTopRightRadius: "15px"}}
                                                alt={img}
                                            />
                                        </Carousel.Item>
                                    ))
                                    }
                                </Carousel>
                        </div>
                        <div className="card-body pb-0">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <h5 className="text-dark">No.{product.num} {product.name}</h5>
                                    <p className="small text-muted">{product.type}/{product.size}인치</p>
                                </div>
                                <div>
                                    <div style={{borderRadius: "0.5rem", paddingRight:"0.4rem", paddingLeft:"0.4rem"}} className={getStatus(product.reserv_date, product.return_date, product.repair, product.damage)}>
                                    {getStatus(product.reserv_date, product.return_date, product.repair, product.damage)} 
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr className="my-0" />
                        <div className="card-body pb-0">
                            <div className="d-flex justify-content-between">
                                <p className="text-dark">오픈타입</p>
                                <p className="text-dark"><strong>{product.zip ? "지퍼방식" : "원터치방식"}</strong></p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p className="text-dark">확장여부</p>
                                <p className="text-dark"><strong>{product.extension ? "확장가능" : "확장불가"}</strong></p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p className="text-dark">바퀴갯수</p>
                                <p className="text-dark"><strong>{product.wheels}개</strong></p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p className="text-dark">사이드핸들</p>
                                <p className="text-dark"><strong>{product.sidehandle ? "있음" : "없음"}</strong></p>
                            </div>
                            {function(){
                                if(product.return_date === null ||
                                    new Date(product.return_date).getTime() < today.getTime()
                                    || product.repair || product.damage ){
                                    return null;
                                } else {
                                    return (
                                    <>
                                        <hr className="my-0" />
                                        <div className="d-flex justify-content-between">
                                            <p className="text-dark">대여예정일</p>
                                            <p className="text-dark"><strong>{product.reserv_date}</strong></p>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <p className="text-dark">반납예정일</p>
                                            <p className="text-dark"><strong>{product.return_date}</strong></p>
                                        </div>
                                    </>
                                    )
                                }
                            }()}
                            {editing ? null :
                                (product.desc && 
                                <div className="d-flex justify-content-between">
                                    <p className="text-dark">
                                        특징 _ {product.desc}
                                    </p>
                                </div>
                                )
                            }
                            {product.type === "미니캐리어" && 
                            <div className="d-flex justify-content-between">
                                <p className="text-dark">
                                *미니캐리어는 개별대여가 불가하며 일반캐리어 대여 시 추가가능합니다.(+2,000원)
                                </p>
                            </div>
                            }
                        </div>
                        {editing ?
                            <form onSubmit={onSubmit}>
                                <hr className="my-0" />
                                <br />
                                <div style={{textAlign: "center"}}>
                                        <DateRange
                                            ranges={state}
                                            locale={ko}
                                            onChange={(item) => {
                                                setState([item.selection])
                                            }}
                                            required
                                        />
                                    </div>
                                <div className="card-body pb-0">
                                    <hr className="my-0" />
                                    <div className="d-flex justify-content-between">
                                        <p className="text-dark">대여일수</p>
                                        <p className="text-dark"><strong>{days}</strong></p>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <p className="text-dark">수리여부</p>
                                        <p className="text-dark">
                                            <strong>
                                                <label htmlFor="repair">
                                                    <input type="checkbox" defaultChecked={repair} name='repair' id='repair' value={repair} onClick={getRepair} /> 수리 중
                                                </label>
                                            </strong>
                                        </p>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <p className="text-dark">파손여부</p>
                                        <p className="text-dark">
                                            <strong>
                                                <label htmlFor="damage">
                                                    <input type="checkbox" defaultChecked={damage} name='damage' id='damage' value={damage} onClick={getDamage} /> 파손
                                                </label>
                                            </strong>
                                        </p>
                                    </div>
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <p className="text-dark">특징</p>
                                            <div className="form-outline">
                                                <textarea className="form-control" id="textAreaExample" value={desc} onChange={onChange} rows="3"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="my-0" />
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <button className="btn btn-primary" onClick={handleEditing}><strong>수정취소</strong></button>
                                            <input type="button" className="btn btn-primary edit" style={{fontWeight: "bold"}} onClick={onSubmit} value="수정완료" />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        : 
                        <>
                        <hr className="my-0" />
                        <div className="card-body">
                            {editing || product.type === "미니캐리어" || product.repair || product.damage ? null
                            :
                            <p className="text-dark" style={{marginTop: "0"}}>
                                *대여제품 특성상, 사진과 실제가 차이가 있을 수 있습니다.
                                <br />*현재 <strong>동작구</strong>와 <strong>성북구</strong>에서만 수령 가능합니다.
                                <br />*주문은 <strong>최소 이틀 전</strong>에 해주셔야 합니다.
                            </p>
                            }
                            <div className="d-flex justify-content-between align-items-center pb-2 mb-1">
                            {userObj && userObj.email === "carryvilly@gmail.com" && !editing ? 
                                <button
                                    className="btn btn-primary edit"
                                    type="button"
                                    onClick={handleEditing}
                                >
                                    <strong>수정하기</strong>
                                </button>
                                : <h5 className="text-dark fw-bold" style={{marginBottom: "0"}}>CARRYVILLY</h5>
                            }
                            {(function(){
                                if(product.type === "미니캐리어" || product.repair || product.damage){
                                    return (<h5>대여불가</h5>)
                                } else {
                                    return (
                                        <Link
                                            to={process.env.PUBLIC_URL + `/product-order/${product.fbid}`}
                                        >
                                            <button
                                                className="btn btn-primary"
                                                type="button"
                                            >
                                                <strong>주문하기</strong>
                                            </button>
                                        </Link>
                                    )
                                }})()
                            }
                            </div>
                        </div>
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Productinfo;